import { render } from "./tableList.vue?vue&type=template&id=affbd494&scoped=true"
import script from "./tableList.vue?vue&type=script&lang=js"
export * from "./tableList.vue?vue&type=script&lang=js"

import "./tableList.vue?vue&type=style&index=0&id=affbd494&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-affbd494"]])

export default __exports__